(function () {
  if (window.__adWishlist) return;
  window.__adWishlist = true;

  var KEY = 'abstracta:wishlist';
  var HEART = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.5 8.2 3.4 5 6.6 5c2 0 3.4 1.1 4.4 2.6h2C14 6.1 15.4 5 17.4 5c3.2 0 5.1 3.2 3.9 6.3-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg>';

  function read() {
    try { var l = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(l) ? l : []; } catch (e) { return []; }
  }
  function write(l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} }
  function bubble() {
    var b = document.querySelector('.wishlist-count-bubble');
    if (!b) return;
    var n = read().length;
    var s = b.querySelector('span[aria-hidden]');
    if (s) s.textContent = n;
    b.hidden = n === 0;
  }
  function has(h) { return read().indexOf(h) !== -1; }
  function toggle(h) {
    var l = read();
    var i = l.indexOf(h);
    if (i === -1) l.push(h); else l.splice(i, 1);
    write(l);
    bubble();
    refresh();
    renderPage();
  }

  var css = document.createElement('style');
  css.textContent = '.ad-wish-host{position:relative}.ad-wish{position:absolute;top:8px;right:8px;z-index:4;width:36px;height:36px;border-radius:50%;border:0;background:#fff;color:#16281f;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 1px 4px rgba(0,0,0,.2);padding:0}.ad-wish svg{fill:none;stroke:currentColor;stroke-width:2;stroke-linejoin:round}.ad-wish.is-on{color:#c0392b}.ad-wish.is-on svg{fill:currentColor}.ad-wish-pdp{position:static;display:flex;gap:8px;width:100%;height:auto;border-radius:12px;border:1px solid #cfd8cf;box-shadow:none;margin-top:10px;padding:12px 16px;font:inherit;font-size:1.5rem;background:#fff;color:#16281f}.ad-wl-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(160px,1fr));gap:16px;padding:16px 0}.ad-wl-card{position:relative;border:1px solid #e3dccb;border-radius:12px;overflow:hidden;background:#fff}.ad-wl-card img{width:100%;aspect-ratio:3/4;object-fit:cover;display:block}.ad-wl-card a{text-decoration:none;color:inherit}.ad-wl-info{padding:10px}.ad-wl-title{font-size:1.4rem;line-height:1.3;margin:0 0 4px}.ad-wl-price{font-size:1.4rem;font-weight:600;margin:0}.ad-wl-empty{padding:32px 0;text-align:center}';
  document.head.appendChild(css);

  function handleFrom(href) {
    try {
      var p = new URL(href, location.origin).pathname;
      var m = p.match(/\/products\/([^\/?#]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) { return null; }
  }

  function makeBtn(h, pdp) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'ad-wish' + (pdp ? ' ad-wish-pdp' : '');
    b.setAttribute('data-ad-wish', h);
    b.innerHTML = HEART + (pdp ? '<span class="ad-wish-txt"></span>' : '');
    return b;
  }

  function refresh() {
    document.querySelectorAll('[data-ad-wish]').forEach(function (b) {
      var on = has(b.getAttribute('data-ad-wish'));
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
      var t = b.querySelector('.ad-wish-txt');
      if (t) t.textContent = on ? 'Saved in wishlist' : 'Add to wishlist';
    });
  }

  function inject() {
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      if (card.querySelector('[data-ad-wish]')) return;
      var a = card.querySelector('a[href*="/products/"]');
      var h = a && handleFrom(a.getAttribute('href'));
      if (!h) return;
      card.classList.add('ad-wish-host');
      card.appendChild(makeBtn(h, false));
    });
    var ph = handleFrom(location.pathname);
    if (ph && !document.querySelector('.ad-wish-pdp')) {
      var anchor = document.querySelector('.pwa') || document.querySelector('.product-form__buttons');
      if (anchor && anchor.parentNode) {
        var pb = makeBtn(ph, true);
        anchor.parentNode.insertBefore(pb, anchor.nextSibling);
      }
    }
    refresh();
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ad-wish]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(b.getAttribute('data-ad-wish'));
  }, true);

  function money(c) { return 'Rs. ' + Math.round(c / 100).toLocaleString('en-US'); }

  function renderPage() {
    var box = document.querySelector('[data-ad-wishlist-page]');
    if (!box) return;
    var list = read();
    if (!list.length) {
      box.innerHTML = '<div class="ad-wl-empty"><p>Aapki wishlist abhi khali hai. Suit par dil (heart) dabayein, wo yahan save ho jayega.</p><p><a class="button" href="/collections/all">Suits dekhein</a></p></div>';
      return;
    }
    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      var html = '<div class="ad-wl-grid">';
      items.forEach(function (p, i) {
        if (!p) return;
        var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') : '';
        html += '<div class="ad-wl-card ad-wish-host"><a href="' + p.url + '"><img src="' + img + '" alt="" loading="lazy"><div class="ad-wl-info"><p class="ad-wl-title"></p><p class="ad-wl-price">' + money(p.price) + '</p></div></a><button type="button" class="ad-wish is-on" data-ad-wish="' + list[i] + '" aria-label="Remove from wishlist">' + HEART + '</button></div>';
      });
      html += '</div>';
      box.innerHTML = html;
      var titles = box.querySelectorAll('.ad-wl-title');
      var k = 0;
      items.forEach(function (p) { if (p) { titles[k++].textContent = p.title; } });
    });
  }

  function start() {
    bubble();
    inject();
    renderPage();
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(inject, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
